export const hasValidWeight = value => typeof value === 'number' && Number.isFinite(value) && value > 0 && value < 300;
export const weightDisplay = (value, language = 'EN') => hasValidWeight(value)
  ? `${value} kg`
  : language === 'IT' ? 'Peso non disponibile' : 'Weight unavailable';

export const weightChartEntries = entries => {
  const valid = [...entries].filter(e => hasValidWeight(e.weight_kg)).reverse().slice(-15);
  return valid.length >= 2 ? valid : [];
};